import React, { useState } from 'react'
import Select from "react-select"
import { ToastContainer, toast } from 'react-toastify'
import { Navigate, useNavigate } from 'react-router-dom'
import '../Video/Addvideo.css'
import { AddMemberApi } from '../../Services/allApi'
function AddMember() {
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        sur_name: "",
        member_name: "",
        member_constituency: [],
        member_role: "",
        is_non_member: false,
        member_department: "",
        member_start_date: "",
        member_end_date: null
    })

    // Define state variable for the checkbox
    const [isChecked, setIsChecked] = useState(false);

    const roleoptions = [
        { value: 1, label: "Role 1" },
        { value: 2, label: "Role 2" },
        { value: 3, label: "Role 3" },
        { value: 4, label: "Role 4" }
    ]

    const constituencyoption = [
        { value: 1, label: "Dept 1" },
        { value: 2, label: "Dept 2" },
        { value: 3, label: "Dept 3" },
        { value: 75, label: "Dept 4" }
    ]
    const surnameoptions = [
        { value: "shri", label: "Shri" },
        { value: "smt", label: "Smt" },
    ]


    const [selectedOptionconstituency, setselectedOptionconstituency] = useState(null)
    const handlechangedept = (selectedOptionconstituency) => {
        setselectedOptionconstituency(selectedOptionconstituency)
        setFormData({ ...formData, member_constituency: [selectedOptionconstituency.value] })
    }

    const [selectedOptionRole, setSelectedOptionRole] = useState(null)
    const handlechangerole = (selectedOptionRole) => {
        setSelectedOptionRole(selectedOptionRole)
        setFormData({ ...formData, member_role: selectedOptionRole.value })
    }

    const [selectedOptionSurname, setselectedOptionSurname] = useState(null)
    const handlechangesurname = (selectedOptionSurname) => {
        setselectedOptionSurname(selectedOptionSurname)
        setFormData({ ...formData, sur_name: selectedOptionSurname.value })
    }

    // Event handler to toggle the checkbox state
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked); // Toggle the state
        formData.is_non_member=!formData.is_non_member
    };

    const handleAddMember = async () => {
        var MemberApiResult
        if (!formData.member_name) {
            toast.warning("Member name required")
        }
        else if (!formData.sur_name) {
            toast.warning("Sur name required")
        }
        else if(!formData.member_constituency){
            toast.warning("Constituency required")
        }
        else if(!formData.member_department){
            toast.warning("Depaetment required")
        }else if(!formData.member_role){
            toast.warning("Role required")
        }
        else if(!formData.member_start_date){
            toast.warning("Elected date required")
        }
        else {
            var token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json", "Authorization": `${token}`
            }
            console.log(token);
            try {
                MemberApiResult = await AddMemberApi(formData, reqHeader)
                console.log(MemberApiResult);
                if (MemberApiResult.status == 200) {
                    toast.success("Member added successfully")
                }
                else {
                    toast.error("Error while adding Session")
                }
            } catch (err) {
                console.log(err);
                toast.error("There was an error")
            }

        }

        console.log(formData);
    }

    return (

        <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>
            <div className='w-9/12  flex flex-col '>
                <div className='flex justify-center '><h2 className='mt-12 md:text-xl text-md'>Add New Member</h2></div>

                {/* row 1 */}
                <div className='flex flex-row justify-between flex-wrap mt-16'>

                    {/* Member name */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="fname">Menber Name</label>
                        <input value={formData.member_name} onChange={(e) => setFormData({ ...formData, member_name: e.target.value })} type="text" name="" id="fname" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/* Surname */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="Surname">Surname</label>
                        {/* <input type="text" name="" id="videourl" className='w-fll h-12 rounded-lg' style={{border:'1px solid #384D6C'}}/> */}
                        <Select
                            id='Surname'
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={surnameoptions}
                            value={selectedOptionSurname}
                            onChange={handlechangesurname} />
                    </div>

                </div>


                {/* row 2 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* constituency */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="constituency">Department</label>
                        <input value={formData.member_department} onChange={(e) => setFormData({ ...formData, member_department: e.target.value })} type="text" name="" id="constituency" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>


                    {/* Department */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="Departmen">Constituency</label>
                        <Select
                            id='Departmen'
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={constituencyoption}
                            value={selectedOptionconstituency}
                            onChange={handlechangedept} />
                    </div>
                </div>

                {/* row 3 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* Role */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="role">Role</label>
                        {/* <input type="text" name="" id="videourl" className='w-fll h-12 rounded-lg' style={{border:'1px solid #384D6C'}}/> */}
                        <Select
                            id='role'
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={roleoptions}
                            value={selectedOptionRole}
                            onChange={handlechangerole} />
                    </div>

                    {/*start Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="date">Elected Date</label>
                        <input value={formData.member_start_date} onChange={(e) => setFormData({ ...formData, member_start_date: e.target.value })} type="date" name="" id="sdate" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>
                </div>

                {/* row 4 */}
                <div className='flex flex-row justify-between flex-wrap'>


                </div>

                {/* row 5 */}
                <div className='flex flex-row justify-between flex-wrap mb-12'>

                    {/*End Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="endate">End Date</label>
                        <input value={formData.member_end_date} onChange={(e) => setFormData({ ...formData, member_end_date: e.target.value })} type="date" name="" id="endate" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/* Action buttons */}

                    <div className='mt-6 flex flex-row md:w-5/12 w-full flex-wrap'>
                        {/* is non member */}
                        <div className='flex flex-row mt-9 md:w-3/12 w-full'>
                            <label htmlFor="nonMember" className='text-sm'>Non-Member</label>
                            <input
                            checked={isChecked} // Bind the checked state to the state variable
                            onChange={handleCheckboxChange} // Call the event handler on change 
                             type="checkbox" className='w-4 h-5 ms-1' id="nonMember" />
                        </div>

                        <div className='flex md:justify-end justify-center flex-row mt-7 md:w-8/12 w-full '>
                            <button className='h-10 bg-primary w-28 text-white rounded-lg' onClick={handleAddMember}>Save</button>
                            <button className='ms-10 h-10 bg-white w-28 text-primary rounded-lg border-2 hover:bg-blue-200' >Cancel</button>
                        </div>
                    </div>


                </div>




            </div>

            <ToastContainer
                style={{ width: '400px', /* other styles */ }}
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>


    )
}

export default AddMember